import { useLayoutEffect, useState } from 'react';

/** Reveal on entry/upward scrolling; ignore small movements and mobile overscroll. */
export function useScrollHidden(enabled: boolean, routeKey: string): boolean {
  const [hidden, setHidden] = useState(false);
  useLayoutEffect(() => {
    setHidden(false);
    if (!enabled) return;
    const position = (): number =>
      Math.max(
        0,
        Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight),
      );
    let previous = position();
    let distance = 0;
    const update = (): void => {
      const current = position();
      const delta = current - previous;
      previous = current;
      if (current <= 24) {
        distance = 0;
        setHidden(false);
      } else if (delta !== 0) {
        distance = Math.sign(delta) === Math.sign(distance) ? distance + delta : delta;
        if (Math.abs(distance) >= 10) {
          setHidden(distance > 0);
          distance = 0;
        }
      }
    };
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, [enabled, routeKey]);
  return enabled && hidden;
}
